import { TableUserCell } from '../../Table'
import { toUserMultiValue } from '../../User'

function EmailTableRowUser({ item, ...restProps }) {
  const { unread, updated_by: user } = item

  return (
    <TableUserCell
      {...restProps}
      unread={unread}
      value={user ? toUserMultiValue(user) : null}
    />
  )
}

export default EmailTableRowUser
